import {
  WCG_DEFAULT_ICONS,
  WcgIconRegistration,
} from '@wcg/frontend-framework';

export const DASH_BOARD_ICONS: WcgIconRegistration[] = [
  {
    WCG_ICON_NAMESPACE: 'erm',
    // Cache-buster: assets/ files keep the same URL across deploys and are
    // served with max-age=86400, so browsers hold yesterday's sprite for up
    // to a day and newly added symbols render as empty icons. Bump ?v=
    // whenever erm-icons.svg gains or changes a symbol.
    WCG_ICONS_URL: 'assets/icons/erm-icons.svg?v=15',
  },
];

export const ERM_ICONS: WcgIconRegistration[] = [
  ...WCG_DEFAULT_ICONS,
  ...DASH_BOARD_ICONS,
];
